'use client'

import { Button } from '@circlefin/components/lib/Button'

export const CWButton = Button
export const CWButtonLink = Button.Link
